/**
 * We check if the coupon code is valid. If it is, we set it on the form.
 * */
export class ValidateBasketCouponAction {
  static type = '[BASKET] Validate coupon';

  constructor(readonly code: string) {}
}
